import React from 'react';
import { omit, pick, } from 'lodash';
import { format as formatDate, } from 'date-fns';
import { Button, } from 'reactstrap';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import { fields } from '../../shared/models/notification';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import AddButton from '../AddButton';
import EditButton from '../EditButton';

const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const notificationsRef = db.collection('notifications');

// 画像フィールドの値をStorageにアップロードしてdownloadUrl等に変換する。
// 新規に選択された場合は FileList が渡ってくるためアップロードし、
// 既存の保存済み画像（downloadUrlを持つオブジェクト）はそのまま残す。
const processImage = async (image, notificationId) => {
  if(image == null) return image;
  if(image.downloadUrl != null) return image;

  const [file] = Array.from(image);
  if(file == null) return null;

  const path = `notifications/${notificationId}/${(new Date()).getTime()}__${file.name}`;
  const fileRef = storageRef.child(path);
  await fileRef.put(file, { contentType: file.type });
  const downloadUrl = await fileRef.getDownloadURL();
  return {
    downloadUrl,
    storagePath: path,
    uploadedAt: new Date(),
    ...pick(file, ['name', 'type']),
  };
};

export default AdminPage(function AdminNotifications (props) {
  const notifications = useCollectionSubscription(notificationsRef.orderBy('publishedAt', 'desc'));

  const onClickDelete = (notification) => async () => {
    if(!window.confirm('本当に削除しますか？')) return;

    try {
      await notification.ref.delete();
      toast.success('削除しました');
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <div className="admin-notifications container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>お知らせ管理</h4>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <AddButton
            itemRef={notificationsRef.doc()}
            FormModal={ModelFormModal}
            formProps={{ title: 'お知らせ 追加', fields, }}
            processValues={async _ => ({ ..._, image: await processImage(_.image, _.id) })}
          />
        </div>
        <div className="overflow-scroll">
          <table className="table sticky-table">
            <thead className="thead-light text-center">
              <tr className="text-nowrap">
                <th>画像</th>
                <th>タイトル</th>
                <th>掲載開始日</th>
                <th>ポップアップ期間</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                notifications.map((notification) => {
                  const { id, title, image, publishedAt, popupStartAt, popupEndAt, } = notification;

                  return (
                    <tr key={id}>
                      <td className="text-center">
                        {
                          image?.downloadUrl && (
                            <a href={image.downloadUrl} target="_blank">
                              <img src={image.downloadUrl} alt={title} style={{ maxWidth: 80, maxHeight: 60, }} />
                            </a>
                          )
                        }
                      </td>
                      <td>{title}</td>
                      <td className="text-nowrap">
                        {publishedAt && formatDate(publishedAt.toDate(), 'yyyy/MM/dd')}
                      </td>
                      <td className="text-nowrap">
                        {
                          (popupStartAt || popupEndAt) ? (
                            <span>
                              {popupStartAt ? formatDate(popupStartAt.toDate(), 'yyyy/MM/dd') : ''}
                              {' 〜 '}
                              {popupEndAt ? formatDate(popupEndAt.toDate(), 'yyyy/MM/dd') : ''}
                            </span>
                          ) : (
                            <span className="text-muted">-</span>
                          )
                        }
                      </td>
                      <td className="text-nowrap text-right">
                        <EditButton
                          itemRef={notification.ref}
                          FormModal={ModelFormModal}
                          formProps={{ title: 'お知らせ 編集', fields }}
                          processValues={async _ => ({ ...omit(_, ['id', 'ref']), image: await processImage(_.image, id) })}
                        />
                        <Button color="danger" className="ml-1" onClick={onClickDelete(notification)}>
                          <span className="fas fa-trash" />
                        </Button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});
